<template>
    <q-card flat square class="tk-attachments-history">
        <section class="tk-attachments-history__card">
            <header class="tk-attachments-history__header">
                <div class="tk-attachments-history__title">
                    <h2>Attachments</h2>
                    <span>{{ attachmentCount }} {{ attachmentCount === 1 ? "attachment" : "attachments" }}</span>
                </div>
                <q-btn
                    unelevated
                    dense
                    no-caps
                    flat
                    color="primary"
                    icon="add"
                    label="New attachment"
                    @click="$emit('add')"
                />
            </header>
            <div class="tk-attachments-history__body">
                <TkDocumentsPanel
                    ref="documentsPanel"
                    :owner-type="ownerType"
                    :owner-id="ownerId"
                    :show-upload="false"
                    :show-list="true"
                    @count-changed="attachmentCount = $event"
                />
            </div>
        </section>
    </q-card>
</template>

<script>
import TkDocumentsPanel from "@/components/TkClients/TkDocumentsPanel.vue";

export default {
    name: "TkAttachmentsPanel",
    components: {
        TkDocumentsPanel,
    },
    emits: ["add"],
    props: {
        ownerType: {
            type: String,
            required: true,
            validator: value => ["person", "engagement"].includes(value),
        },
        ownerId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            attachmentCount: 0,
        };
    },
    methods: {
        async refresh() {
            await this.$refs.documentsPanel?.loadDocuments();
        },
    },
};
</script>

<style scoped>
.tk-attachments-history {
    width: 100%;
    min-height: 420px;
    padding: 16px 24px 28px;
    box-sizing: border-box;
    background: transparent;
    color: #46544e;
}

.tk-attachments-history__card {
    min-width: 0;
    overflow: hidden;
    border: 1px solid rgba(47, 62, 70, 0.08);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 8px 20px rgba(47, 62, 70, 0.05);
}

.tk-attachments-history__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 60px;
    padding: 10px 18px;
    border-bottom: 1px solid rgba(47, 62, 70, 0.08);
}

.tk-attachments-history__title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tk-attachments-history__title h2 {
    margin: 0;
    color: #3d4b46;
    font-size: 1.15rem;
    font-weight: 600;
    letter-spacing: 0.035em;
}

.tk-attachments-history__title span {
    color: #718079;
    font-size: 0.86rem;
}

.tk-attachments-history__body {
    padding: 18px;
}

@media (max-width: 700px) {
    .tk-attachments-history {
        padding: 12px;
    }

    .tk-attachments-history__header {
        align-items: flex-start;
        padding: 10px 12px;
    }

    .tk-attachments-history__body {
        padding: 14px 12px;
    }
}
</style>
